module.exports = __webpack_public_path__ + "static/img/logo.0f3a7600.png";